import config from 'config';

let _initialized = false;
let _startTime = Date.now();

export function enable() {
  if(!_initialized) {
    const elapsedTime = Date.now() - _startTime;
    const isPageLoad = elapsedTime < 1000;
    init(isPageLoad);
    _initialized = true;
  } else {
    (window as any)[`ga-disable-${config.google.analyticsTrackerID}`] = false;
  }
}

export function disable() {
  (window as any)[`ga-disable-${config.google.analyticsTrackerID}`] = true;
}

function init(isPageLoad: boolean = true) {
  console.log('Initializing Google Analytics');
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any)[`ga-disable-${config.google.analyticsTrackerID}`] = false;

  if(isPageLoad) {
    // this is the initial page load - hide page until Tag Manager has loaded, to prevent flicker from
    // Google Optimize
    initAntiFlicker();
  }

  const script = document.createElement('script') as HTMLScriptElement;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${config.google.tagManagerAccountID}`;
  script.async = true;
  script.onload = () => {
    console.log('Google Analytics initialized');
  };
  script.onerror = err => {
    console.warn('Error initializing Google Analytics', err);
  };
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}

function initAntiFlicker() {
  // anti-flicker snippet (adapted from https://support.google.com/optimize/answer/7100284)
  const doc = document.documentElement;
  const win = window as any;
  doc.style.opacity = '0';
  const hide: any = {};
  hide[config.google.tagManagerAccountID] = true;
  hide.start = Date.now();
  const endHide = hide.end = function(){
    doc.style.opacity = '100';
  };
  (win['dataLayer']=win['dataLayer']||[]).hide=hide;
  setTimeout(function(){
    endHide();
    hide.end=null;
  },4000);
  hide.timeout=4000;
}

export function logPageView(path: string, title: string) {
  // page views handled automatically by tag manager
}